import React from 'react';
import { useNavigation } from '../Navigation/NavigationContext';
import { navigationData } from '../../data/navigationData';
import './Breadcrumbs.css';

interface BreadcrumbItem {
  label: string;
  href: string;
}

const Breadcrumbs: React.FC = () => {
  const { state, updateState } = useNavigation();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Home', href: '/' }
    ];

    if (state.section === 'homeowners') {
      breadcrumbs.push({ label: 'For Homeowners', href: '/homeowners' });
    } else if (state.section === 'pros') {
      breadcrumbs.push({ label: 'For Pros', href: '/pros' });
      
      if (state.product) {
        const productData = navigationData.products[state.product];
        if (productData) {
          breadcrumbs.push({ 
            label: productData.title, 
            href: `/pros/${state.product}` 
          });
          
          if (state.page && state.page !== 'overview') {
            const pageItem = productData.items.find(item => {
              const pathParts = item.href.split('/');
              const pageName = pathParts[pathParts.length - 1] || 'overview';
              return pageName === state.page;
            });
            
            if (pageItem) {
              breadcrumbs.push({ 
                label: pageItem.label, 
                href: state.path 
              });
            }
          }
        }
      }
    } else if (state.section === 'about') {
      breadcrumbs.push({ label: 'About Modernize', href: '/about' });
    }

    return breadcrumbs;
  };

  const handleBreadcrumbClick = (crumb: BreadcrumbItem) => {
    if (crumb.href === '/') {
      updateState({
        section: 'home',
        product: null,
        page: null,
        path: '/'
      });
    } else if (crumb.href === '/homeowners') {
      updateState({
        section: 'homeowners',
        product: null,
        page: null,
        path: '/homeowners'
      });
    } else if (crumb.href === '/pros') {
      updateState({
        section: 'pros',
        product: null,
        page: null,
        path: '/pros'
      });
    } else if (crumb.href === '/about') {
      updateState({
        section: 'about',
        product: null,
        page: null,
        path: '/about'
      });
    } else if (crumb.href.startsWith('/pros/')) {
      const pathParts = crumb.href.split('/');
      const product = pathParts[2];
      const page = pathParts[3] || 'overview';
      
      updateState({
        section: 'pros',
        product: product,
        page: page,
        path: crumb.href
      });
    }
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbs.map((crumb, index) => (
          <li key={crumb.href} className="breadcrumb-item">
            {index === breadcrumbs.length - 1 ? (
              <span>{crumb.label}</span>
            ) : (
              <a
                href={crumb.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleBreadcrumbClick(crumb);
                }}
              >
                {crumb.label}
              </a>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;